import * as THREE from 'three';
import { PlanogramImageController, PlanogramImage } from './PlanogramImage';
export class PlanogramRendererResources {

    static get GENERAL_LAYER() { return 0; }
    static get DECORATOR_LAYER() { return 1; }
    static get DRAG_LAYER() { return 2; }
    static get GRID_LAYER() { return 3; }
    static get ORTHOGRAPHIC_LAYER() { return 4; }
    static get PERSPECTIVE_LAYER() { return 5; }
    static get GIZMO_LAYER() { return 6; }

    static RendererStyle = `
        .tabControl{
            flex:1;
            display:flex;
            flex-direction:column;
            background-color:transparent;
            pointer-events:none;
            overflow: hidden;
        }
        .tabControl.root{
            position:absolute;
            left:0;
            top:0;
            width:100%;
            height:100%;
        }
        .tabControl > .tabBar{
            background-color:#fff;
            color:black;
            font-size:12px;
            pointer-events:all;
            -webkit-user-select:none;
            user-select:none;
            box-sizing: border-box;
            padding: 2px 5px 0 5px;
            white-space: nowrap;
            border-bottom: 1px solid #dde0e1;
            overflow: hidden;
            word-wrap: none;
            position: relative;
            /* display:none; */
            text-overflow: ellipsis;
        }
        .tabControl > .tabContainer{
            flex:1;
            background-color:transparent;
            display:flex;
            flex-direction:row;
            pointer-events:none;
            position:relative;
        }
        .tabControl > .tabContainer.vertical{ flex-direction:column; }
        .tabControl > .tabContainer > .tabResizeBar{
            background-color: #e9edf0;
            height:100%;
            width:5px;
            cursor:ew-resize;
            pointer-events:all;
            -webkit-user-select:none;
            user-select:none;
            flex-grow: 0; 
            flex-shrink: 0; 
        }
        .tabControl > .tabContainer > .tabResizeBar:hover{ background-color: darkgrey; }
        .tabControl > .tabContainer.vertical > .tabResizeBar{
            width:100%;
            height:5px;
            cursor:ns-resize;
        }
        .tabControl > .tabContainer > .tabResizeBar.resizing{
            background-color: #c3c7ca;
            border: dashed 1px black;
        }
        .tabContainer.highlight-top::before,
        .tabContainer.highlight-bottom::before,
        .tabContainer.highlight-left::before,
        .tabContainer.highlight-right::before {
            content: "";
            position: absolute;
            background-color:rgba(10, 130, 235, 0.2);
            outline-offset: -2px;
            outline: 2px dashed #0a82eb;
            z-index: 1000;
        }

        .tabContainer.highlight-top::before {
            top: 0;
            left: 0;
            right: 0;
            height: 50%;
        }

        .tabContainer.highlight-bottom::before {
            bottom: 0;
            left: 0;
            right: 0;
            height: 50%;
        }

        .tabContainer.highlight-left::before {
            top: 0;
            bottom: 0;
            left: 0;
            width: 50%;
        }

        .tabContainer.highlight-right::before {
            top: 0;
            bottom: 0;
            right: 0;
            width: 50%;
        }
        .tabItem{
            display: inline-flex;
            padding: 12px 6px;
            color: #999999;
            font-weight: 400;
            border: none;
            background-color: white;
            transition: none;
            border-left: solid transparent 2px;
            font-size: 13.6px;
            line-height: 20px;
            cursor: pointer;
            position: relative;
            z-index:1;
            font-family:"Source Sans 3 VF", system-ui, -apple-system, "Segoe UI", "Helvetica Neue", "Arial", "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
            min-width: 0;
            min-height: 0;
            align-items: flex-end;
            gap:5px;
        }

        .tabItem > .tabIcon{
            font-family: 'Material Symbols';
        }

        .tabItem > button {
            border: none;
            background-color: transparent;
            color: darkgrey;
            padding: 0;
            font-weight: bolder;
            line-height: initial;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            height: 16px;
            width: 16px;
            border-radius: 3px;
            cursor: pointer;
            margin-left: 5px;
            vertical-align: text-bottom;
        }

        .tabItem > button > svg{
            width:100%;
            height:100%;
        }

        .tabItem > button > svg > line{ 
            stroke-width:1;
            stroke:black; 
        }


        .tabItem > button,
        .tabItem > button:hover,
        .tabItem > button:focus,
        .tabItem > button:active {
            outline:none;
        }
        
        .tabItem > button:hover{
            background-color:var(--fr-neutral-400);
            color: white;
        }
        .tabItem > button:hover > svg > line{ stroke:white;  }
        
        .tabItem:last-child{  border-right: solid transparent 2px; }
        .tabItem.dragLeft::before,
        .tabItem.dragRight::before{
            content:"";
            position:absolute;
            top:0;
            bottom:0;
            border-right:3px solid rgb(10, 130, 235);
        }
        .tabItem.dragLeft::before{ left:-5px; }
        .tabItem.dragRight::before{ right:-5px; }

        .tabControl.focused > .tabBar > .tabItem{
            color: black;
            font-weight: normal;
        }
        .tabControl.focused > .tabBar > .tabItem.active{
            font-weight: 600;
        }

        .tabItem.active> button > svg > line{ stroke-width:2; }

        .tabItem.active::after{
            content: "";
            position: absolute;
            z-index: 1;
            background-color: #999999;
            opacity: 1;
            inset: auto auto 0 0;
            width: 100%;
            height: 2px;
            border-radius: 2px 2px 0 0;
        }

        .tabItem.active::after{ background-color:#1B7BC4; }

        .tabGhost{
            position: absolute;
            max-width: 200px;
            opacity:0.7;
            background-color:rgb(10, 130, 235);
            color:white;
            padding:5px;
            overflow:hidden;
            text-overflow:ellipsis;
            border-radius:5px;
            z-index:5;
        }

        .renderer{
            position:absolute;
            left:0px;
            top:0px;
            width:100%;
            height:100%;
        }
        .rendererContainer{
            position:relative;
            display:flex;
            flex-direction:column;
            width:100%;
            height:100%;
        }
        .statusBar{
            height:30px;
            line-height:30px;
            background-color:#ccc;
            color:black;
            font-size:12px; 
            padding:0px 5px;
        }
        .statusBar.hidden{
            display:none;
        }
        .renderView{
            flex-grow:1;
            position:relative;
        }

        .cameraScrollbar{
            position:absolute;
            z-index:2;
            pointer-events:auto;
            overflow-x:auto;
            overflow-y:hidden;
            scrollbar-gutter:stable;
            background:transparent;
        }

        .cameraScrollbar.hidden{
            display:none;
        }

        .cameraScrollbarSpacer{
            height:1px;
        }
            .cameraMinimap{
                position:absolute;
                z-index:3;
                pointer-events:auto;
                border:1px solid rgba(255, 255, 255, 0.28);
                overflow:hidden;
                background:rgba(8, 18, 28, 0.74);
                box-shadow:0 10px 24px rgba(0, 0, 0, 0.24);
                backdrop-filter:blur(4px);
            }

            .cameraMinimap.hidden{
                display:none;
            }

            .cameraMinimapCanvas{
                display:block;
                width:100%;
                height:100%;
            }

            .cameraMinimapViewport{
                position:absolute;
                z-index:1;
                border:1px solid rgba(255, 255, 255, 0.88);
                background:rgba(100, 181, 246, 0.22);
                box-shadow:inset 0 0 0 1px rgba(8, 18, 28, 0.28);
                cursor:grab;
            }

            .cameraMinimapViewport.dragging{
                cursor:grabbing;
            }

            .cameraMinimapResizeHandle{
                position:absolute;
                left:0;
                top:0;
                z-index:2;
                width:16px;
                height:16px;
                cursor:nwse-resize;
                touch-action:none;
                background:linear-gradient(315deg, transparent 0 46%, rgba(255, 255, 255, 0.72) 46% 54%, transparent 54% 100%);
            }

            .cameraMinimapResizeHandle.dragging{
                background:linear-gradient(315deg, transparent 0 42%, rgba(255, 255, 255, 0.92) 42% 58%, transparent 58% 100%);
            }

            .cameraAxisIndicator{
                position:absolute;
                z-index:3;
                pointer-events:none;
                display:flex;
                flex-direction:column;
                align-items:center;
            }

            .cameraAxisIndicator.hidden{
                display:none;
            }

            .cameraAxisIndicatorLabel{
                flex:0 0 auto;
                width:100%;
                text-align:center;
                font-size:13px;
                line-height:16px;
                color:rgba(20, 20, 20, 0.92);
                text-shadow:0 1px 2px rgba(255, 255, 255, 0.65);
                white-space:nowrap;
                overflow:hidden;
                text-overflow:ellipsis;
            }
    `;
    static SelectBoxShader = new THREE.ShaderMaterial({
        uniforms: {
            borderColour: { value: new THREE.Color('black') },
            gridColour: { value: new THREE.Color('rgba(23, 72, 97, 1)') },
            unitSize: { value: 4.0 },
            gridLineWidth: { value: 1 }
        },
        transparent: true,
        depthTest: true,
        depthWrite: false,
        polygonOffset: true,
        polygonOffsetFactor: -1,
        side: THREE.DoubleSide,
        vertexShader: `
            attribute vec3 size;
            attribute vec3 direction;

            varying vec2 vUv;
            varying vec2 vSize;
            varying vec3 vNormal;
            varying vec3 vdirection;

            vec2 GetDimensions( vec3 size, vec3 normal ){
                if( normal.x == 1.0 || normal.x == -1.0 ) return vec2( size.z, size.y );
                if( normal.y == 1.0 || normal.y == -1.0 ) return vec2( size.x, size.z );
                if( normal.z == 1.0 || normal.z == -1.0 ) return vec2( size.x, size.y );
                return vec2( 0.0, 0.0 );
            }

            void main() {
                vUv = uv;
                vSize = GetDimensions(size, normal);
                vNormal = normal;
                vdirection = direction;
                gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
                #ifdef USE_INSTANCING
                    gl_Position = projectionMatrix * viewMatrix * modelMatrix * instanceMatrix * vec4(position, 1.0);
                #endif
            }
        `,
        fragmentShader: `
            float lineWidth = 0.5;
            vec3 highlightColour = vec3( 0.2, 0.63, 0.85 );
            uniform vec3 borderColour;
            uniform float gridLineWidth;
            uniform float unitSize;
            uniform vec3 gridColour;
            
            varying vec3 vdirection;
            varying vec2 vUv;
            varying vec2 vSize;
            varying vec3 vNormal;

            float getGradient(){
                if( vdirection == vec3(0,0,0) ||  vdirection == vec3(1,1,1) ) return 0.0;
                if( round(vdirection) == round(vNormal) ) return 1.0;
                if( round(vdirection) * vec3(-1,-1,-1) == round(vNormal) ) return 0.0;
                
                if(vdirection.x != 0.0){
                    if(vNormal.y != 0.0)
                        return mix(1.0 - vUv.x, vUv.x, step(0.0, vdirection.x));
                    if(vNormal.z != 0.0)
                        return mix(1.0 - vUv.x, vUv.x, step(0.0, sign(vdirection.x) * sign(vNormal.z)));
                }
                if(vdirection.y != 0.0){
                    if(vNormal.z != 0.0 || vNormal.x != 0.0)
                        return vdirection.y > 0.0 ? vUv.y : 1.0 - vUv.y;
                }
                if(vdirection.z != 0.0){
                    if(vNormal.y != 0.0)
                        return mix( vUv.y, 1.0 - vUv.y, step(0.0, sign(vdirection.z) * sign(vNormal.y)));
                    if(vNormal.x != 0.0)
                        return mix( vUv.x, 1.0 - vUv.x, step(0.0, sign(vdirection.z) * sign(vNormal.x)));
                }
                return 0.0;
            }

            void main() {
                float gradient = getGradient();

                float borderWidth = (0.8 / vSize.x);
                float borderHeight = (0.8 / vSize.y);
                vec2 cellSize = vec2( unitSize/vSize.x, unitSize/vSize.y);
                bool isGrid = mod(vUv.x, cellSize.x) < (gridLineWidth / vSize.x) || mod(vUv.y, cellSize.y) < (gridLineWidth / vSize.y);

                if( vdirection == vec3(1,1,1) && (vUv.x < borderWidth || vUv.x > 1.0 - borderWidth || vUv.y < borderHeight || vUv.y > 1.0 - borderHeight)) { gl_FragColor = vec4( borderColour, 1.0 ); }
                else if( gradient > 0.0 ){ gl_FragColor = vec4( highlightColour, gradient );}
                else discard;
            }`
    });
    static DragShader = new THREE.ShaderMaterial({
        transparent: true,
        depthTest: false,
        depthWrite: false,
        side: THREE.DoubleSide,
        vertexShader: `
            attribute vec3 size;

            varying vec2 vUv;
            varying vec2 vSize;

            vec2 GetDimensions( vec3 size, vec3 normal ){
                if( normal.x == 1.0 || normal.x == -1.0 ) return vec2( size.z, size.y );
                if( normal.y == 1.0 || normal.y == -1.0 ) return vec2( size.x, size.z );
                if( normal.z == 1.0 || normal.z == -1.0 ) return vec2( size.x, size.y );
                return vec2( 0.0, 0.0 );
            }

            void main() {
                vUv = uv;
                vSize = GetDimensions(size, normal);
                gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
                #ifdef USE_INSTANCING
                    gl_Position = projectionMatrix * viewMatrix * modelMatrix * instanceMatrix * vec4(position, 1.0);
                #endif
            }
        `,
        fragmentShader: `
            float lineWidth = 0.5;

            varying vec2 vUv;
            varying vec2 vSize;

            void main() {
                float borderWidth = (lineWidth / vSize.x);
                float borderHeight = (lineWidth / vSize.y);
                if(vUv.x < borderWidth || vUv.x > 1.0 - borderWidth || vUv.y < borderHeight || vUv.y > 1.0 - borderHeight) {
                    gl_FragColor = vec4( 255.0, 223.0, 0.0, 1.0 );
                } else {
                    discard;
                }
            }`
    });
    static DecoratorShader = new THREE.ShaderMaterial({
        uniforms: {
            gridColour: { value: new THREE.Color('rgb( 0 , 0, 0)') },
            unitSize: { value: 10.0 }
        },
        polygonOffset: true,
        polygonOffsetFactor: -1,
        transparent: true,
        depthTest: false,
        depthWrite: false,
        side: THREE.DoubleSide,
        vertexShader: `
            attribute vec2 size;
            varying vec2 vUv;
            varying vec2 vSize;
            void main() {
                vUv = uv;
                vSize = size;
                gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
            }
        `,
        fragmentShader: `
            float lineWidth = 1.0;
            float gridLineWidth = 0.4;
            uniform float unitSize;
            uniform vec3 gridColour;
            varying vec2 vUv;
            varying vec2 vSize;

            void main() {
                vec2 cellSize = vec2( unitSize/vSize.x, unitSize/vSize.y);
                bool isGrid = mod(vUv.x, cellSize.x) < (gridLineWidth / vSize.x) || mod(vUv.y, cellSize.y) < (gridLineWidth / vSize.y);
                float borderWidth = (lineWidth / vSize.x);
                float borderHeight = (lineWidth / vSize.y);

                if( (vUv.x < borderWidth || vUv.x > 1.0 - borderWidth || vUv.y < borderHeight || vUv.y > 1.0 - borderHeight)) { 
                    gl_FragColor = vec4( 0.2, 0.63, 0.85, 1.0 ); 
                }else 
                if( isGrid ){
                    gl_FragColor = vec4( 0.2, 0.63, 0.85,  0.7 );
                } else discard;
            }`
    });
    static DirectionalDecoratorShader = new THREE.ShaderMaterial({
        uniforms: {
            gridColour: { value: new THREE.Color('rgb( 51, 160, 216 )') },
            unitSize: { value: 5.0 },
            lineWidth: { value: 1.0 },
            gridLineWidth: { value: 0.4 }
        },
        polygonOffset: true,
        polygonOffsetFactor: -1,
        transparent: true,
        depthTest: false,
        depthWrite: false,
        side: THREE.DoubleSide,
        vertexShader: `
            attribute vec2 size;
            varying vec2 vUv;
            varying vec2 vSize;
            varying vec3 vNormal;

            vec2 GetDimensions( vec3 size, vec3 normal ){
                if( normal.x == 1.0 || normal.x == -1.0 ) return vec2( size.z, size.y );
                if( normal.y == 1.0 || normal.y == -1.0 ) return vec2( size.x, size.z);
                if( normal.z == 1.0 || normal.z == -1.0 ) return vec2( size.x, size.y );
                return vec2( 0.0, 0.0 );
            }
            void main() {
                vUv = uv;
                vSize = GetDimensions( size, normal );
                vNormal = normal;
                gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
            }
        `,
        fragmentShader: `
            uniform float lineWidth;
            uniform float gridLineWidth;
            uniform float unitSize;
            uniform vec3 gridColour;

            varying vec2 vUv;
            varying vec2 vSize;
            varying vec3 vNormal;

            void main() {
            
                vec2 cellSize = vec2( unitSize/vSize.x, unitSize/vSize.y);
                bool isGrid = mod(vUv.x, cellSize.x) < (gridLineWidth / vSize.x) || mod(vUv.y, cellSize.y) < (gridLineWidth / vSize.y);
                float borderWidth = (lineWidth / vSize.x);
                float borderHeight = (lineWidth / vSize.y);

                if( (vUv.x < borderWidth || vUv.x > 1.0 - borderWidth || vUv.y < borderHeight || vUv.y > 1.0 - borderHeight)) { 
                    gl_FragColor = vec4( gridColour, 1.0 ); 
                }else 
                if( isGrid ){
                    gl_FragColor = vec4( gridColour,  0.7 );
                } else discard;
            }`
    });
    static BlockShader = new THREE.ShaderMaterial({
        side: THREE.DoubleSide,
        transparent: true,
        uniforms: {},
        polygonOffset: true,
        polygonOffsetFactor: -5,
        vertexShader: `
            attribute vec4 fillOptions;
            attribute vec3 size;
            attribute vec3 dividerLines;

            varying vec2 vUv;
            varying vec4 vfillOptions;
            varying vec2 vSize;
            varying vec3 vNormal;
            varying vec3 vDividerLine;

            vec2 GetDimensions( vec3 size, vec3 normal ){
                if( normal.x == 1.0 || normal.x == -1.0 ) return vec2( size.z, size.y );
                if( normal.y == 1.0 || normal.y == -1.0 ) return vec2( size.x, size.z);
                if( normal.z == 1.0 || normal.z == -1.0 ) return vec2( size.x, size.y );
                return vec2( 0.0, 0.0 );
            }

            void main() {
                vUv = uv;
                vfillOptions = fillOptions;
                vSize = GetDimensions( size, normal );
                vNormal = normal;
                vDividerLine = dividerLines;

                gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
                #ifdef USE_INSTANCING
                    gl_Position = projectionMatrix * viewMatrix * modelMatrix * instanceMatrix * vec4(position, 1.0);
                #endif
            }
    `,
        fragmentShader: `
            varying vec2 vUv;
            varying vec4 vfillOptions;
            varying vec2 vSize;
            varying vec3 vNormal;
            varying vec3 vDividerLine;

            vec3 GetRGB(float colour){
                float r = floor(colour / 65536.0);
                float g = floor((colour - r * 65536.0) / 256.0);
                float b = mod(colour, 256.0);
                return vec3(r/255.0, g/255.0, b/255.0);
            }

            bool showDividerLine( float type, vec3 normal ){
                if(type == 1.0 && (normal.y == 1.0 || normal.y == -1.0)) return true;
                if(type == 1.0 && (normal.z == 1.0 || normal.z == -1.0)) return true;
                if(type == 2.0 && (normal.x == 1.0 || normal.x == -1.0)) return true;
                if(type == 2.0 && (normal.z == 1.0 || normal.z == -1.0)) return true;
                return false;
            }

            void main() {
                
                // 0.0: not selected, 1.0: selected, 
                float colour = vfillOptions.x;
                bool isSelected = vfillOptions.y == 1.0;
                float outerBorderWidth = 1.5;
                float innerBorderWidth = 1.5;
                float dividerLinesWidth = 0.5;
                vec2 linewidths = vec2(( 1.0 / vSize.x ) * outerBorderWidth, ( 1.0 / vSize.y ) * outerBorderWidth);
                vec2 innerLineWidths = vec2(( 1.0 / vSize.x ) * innerBorderWidth, ( 1.0 / vSize.y ) * innerBorderWidth);
                bool isOuterBorderX = vUv.x < linewidths.x / 2.0 || vUv.x > (1.0 - linewidths.x / 2.0);
                bool isOuterBorderY = vUv.y < linewidths.y / 2.0 || vUv.y > (1.0 - linewidths.y / 2.0);

                bool isInnerBorderX1 = vUv.x > innerLineWidths.x / 2.0  && vUv.x < innerLineWidths.x / 2.0  + innerLineWidths.x / 2.0;
                bool isInnerBorderX2 = vUv.x > (1.0 - innerLineWidths.x / 2.0 ) - innerLineWidths.x / 2.0 && vUv.x < (1.0 - innerLineWidths.x / 2.0);
                bool isInnerBorderY1 = vUv.y > innerLineWidths.y / 2.0  && vUv.y < innerLineWidths.y / 2.0  + innerLineWidths.y / 2.0;
                bool isInnerBorderY2 = vUv.y > (1.0 - innerLineWidths.y / 2.0 ) - innerLineWidths.y / 2.0 && vUv.y < (1.0 - innerLineWidths.y / 2.0);

                vec2 adjDivider = vDividerLine.xy;
                if( vDividerLine.z == 1.0 && vNormal.z == -1.0 ){ adjDivider.x = 1.0 - adjDivider.x; }
                bool isDividerLineY = vUv.x > adjDivider.x - (dividerLinesWidth / vSize.x) / 2.0 && vUv.x < adjDivider.x + (dividerLinesWidth / vSize.x) / 2.0;
                bool isDividerLineX = vUv.y > adjDivider.y - (dividerLinesWidth / vSize.y) / 2.0 && vUv.y < adjDivider.y + (dividerLinesWidth / vSize.y) / 2.0;
                bool canShowDivider = showDividerLine( vDividerLine.z, vNormal );
               
                float aspectRatio = vSize.x / vSize.y;
                float penSize = 4.0;
                float spacing = 5.0;
                float adjustedSpacing = ( 1.0/vSize.x) * (spacing + penSize/2.0);
                float actualSpacing = ( 1.0/vSize.x) * spacing;
                float adjustedPenSize = penSize / vSize.x;
                float radius = ( 1.0/vSize.x) * (penSize / 2.0); // Radius is half the diameter

                float mod1 = step( adjustedPenSize, mod(vUv.x - (vUv.y / aspectRatio), adjustedSpacing));
                float mod2 = step( adjustedPenSize, mod( vUv.x + (vUv.y/ aspectRatio), adjustedSpacing ) );
                float mod3 = step( adjustedPenSize, mod( vUv.x - 0.035, adjustedSpacing ) );
                float mod4 = step( adjustedPenSize, mod( (vUv.y / aspectRatio) - 0.035, adjustedSpacing ) );

                vec2 position = vec2(vUv.x,vUv.y/aspectRatio) / vSize.xy;
                vec2 gridPosition = mod(position * vSize.xy / actualSpacing, 1.0);
                vec2 circleCenter = vec2(0.5, 0.5);
                float distanceFromCenter = length(gridPosition - circleCenter);
                float normalizedRadius = radius / actualSpacing;

                if( canShowDivider && ( (vDividerLine.z == 2.0 && isDividerLineX ) || ( vDividerLine.z == 1.0 && isDividerLineY ))){
                    gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0);
                }else if (isSelected && (isInnerBorderX1 || isInnerBorderX2 || isInnerBorderY1 || isInnerBorderY2) && !(isOuterBorderX || isOuterBorderY)) {
                    gl_FragColor = vec4( 1.0,1.0,1.0, 1.0);
                }else if(vfillOptions.w == 0.0){
                    discard;
                }else if(vfillOptions.w == 2.0){
                    if(isSelected){
                        gl_FragColor = vec4( 1.0,1.0,1.0, 1.0);
                    }else{
                        gl_FragColor = vec4( 0.0,0.0,0.0, 1.0);
                    }
                }else{
                    if( (vfillOptions.z <= 1.0) ||
                    (vfillOptions.z == 2.0 && mod1 < 0.5) || 
                    (vfillOptions.z == 3.0 && mod2 < 0.5) || 
                    (vfillOptions.z == 4.0 && (mod1 < 0.5 || mod2 < 0.5)) ||  
                    (vfillOptions.z == 5.0 && mod4 < 0.5) || 
                    (vfillOptions.z == 6.0 && mod3 < 0.5) || 
                    (vfillOptions.z == 7.0 && distanceFromCenter < normalizedRadius)){
                        gl_FragColor = vec4( GetRGB(colour), 0.6 );
                    }else{
                        gl_FragColor = vec4( GetRGB(colour), 0.0 );
                    }
                }
            }`
    });
    static TextShader = () => new THREE.ShaderMaterial({
        uniforms: {
            image: { value: null },
            imageSize: { value: new THREE.Vector2(128, 128) },
        },
        transparent: true,
        vertexShader: ` 
            // x: width, y: height, z: depth
            attribute vec3 size;
            // x: innerWidth, y: innerHeight, z:imageDepth, w: text-direction
            attribute vec4 frontBack;
            // x: innerWidth, y: innerHeight, z:imageDepth, w: text-direction
            attribute vec4 leftRight;
            // x: innerWidth, y: innerHeight, z:imageDepth, w: text-direction
            attribute vec4 topBottom;

            // x: h-alignment, y: v-alignment, z: isAttached
            attribute vec3 labelOptions;
            // x: border colour, y: background colour, z: text colour, w: border 
            attribute vec4 colourOptions;

            varying vec3 vlabelOptions;
            varying vec4 vcolourOptions;
            varying vec4 vfrontBack;
            varying vec4 vleftRight;
            varying vec4 vtopBottom;
            varying vec2 vSize;
            varying float isAttached;

            varying vec3 vnormal;
            varying vec2 vUv;

            vec2 GetDimensions( vec3 size, vec3 normal ){
                if( normal.x == 1.0 || normal.x == -1.0 ) return vec2( size.z , size.y );
                if( normal.y == 1.0 || normal.y == -1.0 ) return vec2( size.x , size.z );
                if( normal.z == 1.0 || normal.z == -1.0 ) return vec2( size.x , size.y );
                return vec2( 0.0, 0.0 );
            }
                
            void main() {
                vfrontBack = frontBack;
                vleftRight = leftRight;
                vtopBottom = topBottom;
                vlabelOptions = labelOptions;
                vcolourOptions = colourOptions;
                vnormal = normal;
                vUv = uv;
                vSize = GetDimensions( size, normal );
                isAttached = labelOptions.z;
                gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
                #ifdef USE_INSTANCING
                    gl_Position = projectionMatrix * viewMatrix * modelMatrix * instanceMatrix * vec4(position, 1.0);
                #endif

            } `,
        fragmentShader: `
            uniform sampler2DArray image;
            uniform vec2 imageSize;

            varying vec3 vlabelOptions;
            varying vec4 vcolourOptions;
            varying vec4 vfrontBack;
            varying vec4 vleftRight;
            varying vec4 vtopBottom;
            varying vec2 vSize;
            varying float isAttached;

            varying vec2 vUv;
            varying vec3 vnormal;

            vec4 GetOptions( vec4 frontBack, vec4 leftRight, vec4 topBottom, vec3 normal ){
                vec3 absNormal = abs(normal);
                if( absNormal.x >= absNormal.y && absNormal.x >= absNormal.z ) return leftRight;
                if( absNormal.y >= absNormal.x && absNormal.y >= absNormal.z ) return topBottom;
                if( absNormal.z >= absNormal.x && absNormal.z >= absNormal.y ) return frontBack;
                return vec4( 0.0, 0.0, 0.0, 0.0 );
            }

            vec3 GetRGB(float colour){
                float r = floor(colour / 65536.0);
                float g = floor((colour - r * 65536.0) / 256.0);
                float b = mod(colour, 256.0);
                return vec3(r/255.0, g/255.0, b/255.0);
            }

            void main() {
                vec4 imageOptions = GetOptions( vfrontBack, vleftRight, vtopBottom, vnormal ); 
                float borderThickness = vcolourOptions.w < 0.25 ? 0.25 : vcolourOptions.w;
                vec2 borders = vec2( borderThickness / vSize.x, borderThickness / vSize.y );
                float margin = 0.25;
                float textDirection = imageOptions.w;
                float horizontalAlignment = vlabelOptions.x;
                float verticalAlignment = vlabelOptions.y;

                if(isAttached == 0.0){
                    horizontalAlignment = 0.0;
                    verticalAlignment = 0.0;
                    textDirection = 0.0;
                }

                vec2 labelDimensions = textDirection == 0.0 ? vec2(imageOptions.x, imageOptions.y) : vec2(imageOptions.y, imageOptions.x); 
                vec2 textSize = textDirection == 1.0 
                    ? vec2(labelDimensions.y * (vSize.y / vSize.x), labelDimensions.x) 
                    : vec2(labelDimensions.x, labelDimensions.y);
                vec2 labelSize = vec2(((labelDimensions.x + (margin * 2.0) + (borderThickness * 2.0)) / vSize.x), 
                    ((labelDimensions.y + (margin * 2.0) + (borderThickness * 2.0)) / vSize.y)) * 0.5;
                vec2 reversedUv = vec2(vUv.x, 1.0 - vUv.y);
                vec2 offset = vec2(0.0, 0.0);

                if(horizontalAlignment == -1.0) offset.x = 0.0; // Left
                if(horizontalAlignment == 0.0) offset.x = 0.5 - labelSize.x / 2.0; // Middle
                if(horizontalAlignment == 1.0) offset.x = 1.0 - labelSize.x; // Right
                if(verticalAlignment == -1.0) offset.y = 1.0 - labelSize.y; // Top
                if(verticalAlignment == 0.0) offset.y = 0.5 - labelSize.y / 2.0; // Middle
                if(verticalAlignment == 1.0) offset.y = 0.0; // Bottom

                vec3 absNormal = abs(vnormal);
                bool isLabelFace = (absNormal.z >= absNormal.x && absNormal.z >= absNormal.y);
                bool canShowFace = isAttached == 1.0 || (isLabelFace && vnormal.z > 0.0);

                if (canShowFace && (vUv.x > offset.x && vUv.x < offset.x + labelSize.x && vUv.y > offset.y && vUv.y < offset.y + labelSize.y)) {
                    vec2 adjustedUv = vec2(
                        (reversedUv.x - offset.x - margin / vSize.x - borderThickness / vSize.x) / (labelSize.x - 2.0 * (margin + borderThickness) / vSize.x),
                        1.0 - (vUv.y - offset.y - margin / vSize.y - borderThickness / vSize.y) / (labelSize.y - 2.0 * (margin + borderThickness) / vSize.y) // Invert adjustedUv.y
                    );

                    if (textDirection == 1.0) { 
                        adjustedUv = vec2(1.0 - adjustedUv.y, adjustedUv.x); // Correct rotation
                        adjustedUv.x *= (vSize.x / vSize.y);
                    }

                    vec2 scaledUv = adjustedUv * (textSize / imageSize);
                    vec4 textureColor = texture(image, vec3(scaledUv, imageOptions.z));
                    bool isNearBlack = textureColor.a > 0.0 && textureColor.r < 0.02 && textureColor.g < 0.02 && textureColor.b < 0.02;
                    vec3 sampledColor = isNearBlack ? GetRGB(vcolourOptions.z) : textureColor.rgb;
                    
                    if (isAttached == 1.0 && (vUv.x < offset.x + borderThickness / vSize.x || vUv.x > offset.x + labelSize.x - borderThickness / vSize.x ||
                        vUv.y < offset.y + borderThickness / vSize.y || vUv.y > offset.y + labelSize.y - borderThickness / vSize.y)) {
                        gl_FragColor = vec4(GetRGB(vcolourOptions.x), 1.0);
                    }else if (textureColor.a < 1.0) {
                        vec3 mixedColor = mix(sampledColor, GetRGB(vcolourOptions.y), 1.0 - textureColor.a); 
                        gl_FragColor = vec4(mixedColor, 1.0); 
                    } else {
                        gl_FragColor = vec4(sampledColor, 1.0);
                    }
                } else if(isAttached == 0.0){
                    if( vUv.x < borders.x || vUv.x > 1.0 - borders.x || vUv.y < borders.y || vUv.y > 1.0 - borders.y ){
                        gl_FragColor = vec4( GetRGB(vcolourOptions.x), 1.0 );
                    }else {
                        gl_FragColor = vec4(GetRGB(vcolourOptions.y),1.0);
                    }
                }else{
                    discard;
                }
            }
        `
    });
    static UnitShader = () => new THREE.ShaderMaterial({
        transparent: true,
        uniforms: {},
        vertexShader: `
            attribute vec3 fillOptions;
            attribute vec3 size;
            attribute vec3 facings;
            attribute vec3 options;
            attribute vec3 trayDimensions;
            attribute vec3 rightLeftTop;
            attribute vec3 bottomFrontBack;

            varying vec2 vUv;
            varying vec3 vfillOptions;
            varying vec2 vfacings;
            varying vec2 vSize;
            varying vec3 vOptions;
            varying vec3 vNormal;
            varying float vdepth;
            

            uniform float shrinkFactor; // Add this line

            vec2 GetDimensions( vec3 size, vec3 normal, vec3 scale ){
                if( normal.x == 1.0 || normal.x == -1.0 ) return vec2( size.z * scale.z, size.y * scale.y );
                if( normal.y == 1.0 || normal.y == -1.0 ) return vec2( size.x * scale.x, size.z * scale.z );
                if( normal.z == 1.0 || normal.z == -1.0 ) return vec2( size.x * scale.x, size.y * scale.y );
                return vec2( 0.0, 0.0 );
            }

            float getDepth( vec3 normal, vec3 rlt, vec3 bfbk ){
                if(normal.x == 1.0) return rlt.x;
                if(normal.x == -1.0) return rlt.y;
                if(normal.y == 1.0) return rlt.z;
                if(normal.y == -1.0) return bfbk.x;
                if(normal.z == 1.0) return bfbk.y;
                if(normal.z == -1.0) return bfbk.z;
            }

            void main() {
                vNormal = normal;
                vUv = uv;
                vdepth = getDepth(normal, rightLeftTop, bottomFrontBack);
                vec3 otherSize = vec3( size.x, size.y, size.z );
                vfillOptions = fillOptions;
                vfacings = GetDimensions( facings, normal, vec3(1.0,1.0,1.0) );
                vOptions = options;

                gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
                #ifdef USE_INSTANCING
                    vec4 instancePosition = instanceMatrix * vec4(position, 1.0);
                    
                    if(fillOptions.y == 2.0 || fillOptions.y == 3.0 || fillOptions.y == 4.0 || fillOptions.y == 1.0){
                        
                        vec3 localOffset = vec3(0.0, 0.0, 0.0);
                        vec3 actualTrayDimensions = vec3(
                            (trayDimensions.x <= 0.0 ? 0.2 : trayDimensions.x) * (1.0/ otherSize.x), 
                            (trayDimensions.y <= 0.0 ? 0.2 : trayDimensions.y) * (1.0/ otherSize.y), 
                            (trayDimensions.z <= 0.0 ? 0.2 : trayDimensions.z) * (1.0/ otherSize.z));

                        if(fillOptions.y == 2.0 || fillOptions.y == 3.0 || fillOptions.y == 4.0){
                            //tray top
                            if (normal.y > 0.0) {
                                localOffset.y = -(1.0 - actualTrayDimensions.y);
                                // otherSize.y -= calc / facings.y;
                            }else
                            // //sides
                            // }else 
                            if(position.y > 0.0){
                                float fixedheight = fillOptions.y == 2.0 ? 0.25 : 0.2;
                                float calculatedHeight = actualTrayDimensions.y + fixedheight; 
                                if(calculatedHeight > 1.0) calculatedHeight = 1.0;
                                localOffset.y = -(1.0-calculatedHeight);
                                otherSize.y -= calculatedHeight;
                            }

                        }else if(fillOptions.y == 1.0){
                            
                            
                            if(position.y < 0.0){ 
                                localOffset.y = actualTrayDimensions.y;
                                otherSize.y -= actualTrayDimensions.y;
                            }
                            if(position.x < 0.0){ 
                                localOffset.x = actualTrayDimensions.x; 
                                otherSize.x -= actualTrayDimensions.x;
                            }
                            if(position.x > 0.0){
                                localOffset.x = -actualTrayDimensions.x;
                                otherSize.x -= actualTrayDimensions.x;
                            }

                            if(position.z < 0.0){
                                localOffset.z = actualTrayDimensions.z;
                                otherSize.z -= actualTrayDimensions.z;
                            }
                            if(position.z > 0.0){
                                localOffset.z = -actualTrayDimensions.z;
                                otherSize.z -= actualTrayDimensions.z;
                            }
                        }

                        instancePosition = instanceMatrix * vec4(position + localOffset, 1.0);
                    }
                    gl_Position = projectionMatrix * viewMatrix * modelMatrix * instancePosition;
                #endif

                vSize = GetDimensions( otherSize, normal, facings );

            }
        `,
        fragmentShader: `
            uniform sampler2DArray image;

            varying vec3 vfillOptions;
            varying vec2 vUv;
            varying vec2 vfacings;
            varying vec2 vSize;
            varying vec3 vNormal;
            varying vec3 vOptions;
            varying float vdepth;

            vec3 GetRGB(float colour){
                float r = floor(colour / 65536.0);
                float g = floor((colour - r * 65536.0) / 256.0);
                float b = mod(colour, 256.0);
                return vec3(r/255.0, g/255.0, b/255.0);
            }

            void main() {
                
                // 0.0: position, 1.0: tray_unit, 2.0: tray, 3.0: case, 4.0: pallet
                float type = vfillOptions.y;
                float lineWidth = vOptions.x;
                vec2 linewidths = vec2(( 1.0 / vSize.x ) * lineWidth, ( 1.0 / vSize.y ) * lineWidth); 
                float facingsX = 1.0 / vfacings.x;
                float facingsY = 1.0 / vfacings.y;
                float borderX = mod(vUv.x, facingsX);
                float borderY = mod(vUv.y, facingsY);
                bool isOuterBorderX = vUv.x < linewidths.x / 4.0 || vUv.x > (1.0 - linewidths.x / 4.0);
                bool isOuterBorderY = vUv.y < linewidths.y / 4.0 || vUv.y > (1.0 - linewidths.y / 4.0);
                bool isBorderX = borderX < (linewidths.x / 4.0) || borderX > (facingsX - (linewidths.x / 4.0));
                bool isBorderY = borderY < (linewidths.y / 4.0) || borderY > (facingsY - (linewidths.y / 4.0));
                bool canShowOuterBorder = type == 0.0 || type == 1.0 && vNormal.y != 1.0 || type == 2.0 && vNormal.y == 1.0 ;
                float modX = step(0.07, mod(vUv.x + vUv.y, 0.2));
                float mod1 = step( 1.0 / vSize.x, mod(vUv.x - (vUv.y / (vSize.x / vSize.y)), ( 1.0/ vSize.x) * 1.5));
                float alpha = vOptions.z > 0.5 ? 0.7 : 1.0;

                if ( (isOuterBorderX || isOuterBorderY) || type == 4.0 && modX == 0.0) {
                    gl_FragColor = vec4(0.0, 0.0, 0.0, alpha);
                } else if( type == 2.0 ){
                    gl_FragColor = vec4(0.70, 0.70, 0.70, alpha);
                } else if( type == 3.0 ){
                    gl_FragColor = vec4(0.84, 0.84, 0.84, alpha);
                } else if( type != 4.0 && (isBorderX || isBorderY)) {
                    if(vOptions.z > 0.5 && mod1 < 0.5) discard;
                    gl_FragColor = vec4(0.0, 0.0, 0.0, alpha);
                }else{
                    float textX = mod(vUv.x, facingsX) / facingsX;
                    float textY = 1.0 - (mod(vUv.y, facingsY) / facingsY);
                    vec4 textureOptions = texture( image, vec3( textX, textY, vdepth ) );
                    if(textureOptions != vec4(0.0,0.0,0.0,0.0)){
                        gl_FragColor = textureOptions;
                    }else{
                        if (vOptions.z > 0.5) { discard; }
                        gl_FragColor = vec4( GetRGB(vfillOptions.x), 1.0 );
                    }
                }
            }`
    });
    static SubcomponentShader = () => new THREE.ShaderMaterial({
        transparent: true,
        uniforms: {

        },
        vertexShader: `
            attribute vec2 texelPositionAndType; // x: texel position to start extracting values, y: type

            varying vec2 vsize;
            varying vec2 vUv;
            varying vec3 vNormal;
            varying vec2 vtexelPositionAndType;

            void main() {

                vec3 size = vec3( length(instanceMatrix[0].xyz), length(instanceMatrix[1].xyz), length(instanceMatrix[2].xyz) );
                vec3 axis = abs(normal);
                vsize = size.zy * axis.x + size.xz * axis.y + size.xy * axis.z;

                vtexelPositionAndType = texelPositionAndType;
                vNormal = normal;
                vUv = uv;
                
                gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
                #ifdef USE_INSTANCING
                    gl_Position = projectionMatrix * viewMatrix * modelMatrix * instanceMatrix * vec4(position, 1.0);
                #endif
            }
        `,
        fragmentShader: `
            uniform sampler2DArray image;
            uniform sampler2D objectData;

            varying vec2 vsize;
            varying vec2 vUv;
            varying vec3 vNormal;
            varying vec2 vtexelPositionAndType;


            vec3 GetRGB(float colour){
                float r = floor(colour / 65536.0);
                float g = floor((colour - r * 65536.0) / 256.0);
                float b = mod(colour, 256.0);
                return vec3(r/255.0, g/255.0, b/255.0);
            }

            vec2 GetColourDirection ( vec4 fbFill, vec4 tbFill, vec4 lrFill, vec3 normal, float type){
                if( type == 0.0 && normal.x == -1.0 || type == 7.0 ) return vec2( lrFill.x, lrFill.y );
                if( type == 0.0 && normal.x == 1.0 || type == 8.0 ) return vec2( lrFill.z, lrFill.w );
                if( type == 0.0 && normal.y == 1.0 || type == 6.0 ) return vec2( tbFill.x, tbFill.y );
                if( type == 0.0 && normal.y == -1.0 || type == 5.0 ) return vec2( tbFill.z, tbFill.w );
                if( type == 0.0 && normal.z == 1.0 || type == 9.0 || type == 11.0 ) return vec2( fbFill.x, fbFill.y );
                if( type == 0.0 && normal.z == -1.0 || type == 10.0 ) return vec2( fbFill.z, fbFill.w );
            }

            float GetImageDepth ( vec3 positive, vec3 negative, vec3 normal ){
                if( normal.x == -1.0 ) return negative.x;
                if( normal.x == 1.0) return positive.x;
                if( normal.y == 1.0 ) return positive.y;
                if( normal.y == -1.0 ) return negative.y;
                if( normal.z == 1.0 ) return positive.z;
                if( normal.z == -1.0 ) return negative.z;
                return 0.0;
            }

            float GetFaceAlpha(float frontA, float backA, float topA, float bottomA, float leftA, float rightA, vec3 normal, float type) {
                if( type == 0.0 && normal.x == -1.0 || type == 7.0  ) return leftA;
                if( type == 0.0 && normal.x == 1.0  || type == 8.0  ) return rightA;
                if( type == 0.0 && normal.y == 1.0  || type == 6.0  ) return topA;
                if( type == 0.0 && normal.y == -1.0 || type == 5.0  ) return bottomA;
                if( type == 0.0 && normal.z == 1.0  || type == 9.0 || type == 11.0 ) return frontA;
                if( type == 0.0 && normal.z == -1.0 || type == 10.0 ) return backA;
                return -1.0;
            }

            void main() {

                int maxWidth = 2048;
                const int stride = 13;

                vec4 instanceData[stride];

                int globalInstanceIndex = int(vtexelPositionAndType.x) * stride;
                for (int i = 0; i < stride; i++) {

                    vec2 pixelCoord = vec2(
                        (globalInstanceIndex + i) % maxWidth, 
                        (globalInstanceIndex + i) / maxWidth
                    );

                    instanceData[i] = texelFetch(objectData, ivec2(pixelCoord), 0);
                }

                vec4 merchRows1 = instanceData[0];
                vec4 merchRows2 = instanceData[1];
                vec4 merchRows3 = instanceData[2];
                vec4 notches1 = instanceData[3];
                vec4 notches2 = instanceData[4];
                vec4 fill1 = instanceData[5];
                vec4 fill2 = instanceData[6];
                vec4 fill3 = instanceData[7];
                vec3 riser = instanceData[8].xyz;
                vec4 options = vec4(instanceData[8].w,instanceData[9].xyz);
                vec4 images1 = vec4(instanceData[9].w,instanceData[10].xyz);
                vec4 images2 = vec4(instanceData[10].w,instanceData[11].xyz);

                float frontFillAlpha  = instanceData[11].y;
                float backFillAlpha   = instanceData[11].z;
                float topFillAlpha    = instanceData[11].w;
                float bottomFillAlpha = instanceData[12].x;
                float leftFillAlpha   = instanceData[12].y;
                float rightFillAlpha  = instanceData[12].z;
                float frontFaceTotalHeight = instanceData[12].w;

                vec2 actualSize = vsize;
                float linecolour = options.x;
                float thickness = options.y;
                float transparency = options.z;
                float vtype = vtexelPositionAndType.y;
                bool isNotchPlane = vtype == 11.0;
                if(isNotchPlane && vNormal.z != 1.0){ discard; }

                float faceAlpha = GetFaceAlpha(frontFillAlpha, backFillAlpha, topFillAlpha, bottomFillAlpha, leftFillAlpha, rightFillAlpha, vNormal, vtype);
                float effectiveAlpha = faceAlpha < 0.0 ? transparency : faceAlpha;

                float riserColour = riser.x;
                float riserStyle = riser.y;
                float riserTransparency = riser.z;
                float vdepth = vtype == 0.0 ? GetImageDepth(vec3(images1.x, images1.z, images2.x), vec3(images1.y, images1.w, images2.y), vNormal) : -1.0;
                vec2 fillOptions = GetColourDirection( fill1, fill2, fill3, vNormal, vtype );

                vec2 uv = vUv;
                uv.y = 1.0 - uv.y;
                vec4 textureOptions = texture( image, vec3( uv, vdepth ) );

                vec2 vborders = vec2( thickness / actualSize.x, thickness / actualSize.y );
                float aspectRatio = actualSize.x / actualSize.y;
                float penSize = 4.0;
                float spacing = 5.0;
                float adjustedSpacing = ( 1.0/actualSize.x) * (spacing + penSize/2.0);
                float actualSpacing = ( 1.0/actualSize.x) * spacing;
                float adjustedPenSize = penSize / actualSize.x;
                float radius = ( 1.0/actualSize.x) * (penSize / 2.0); // Radius is half the diameter

                float mod1 = step( adjustedPenSize, mod(vUv.x - (vUv.y / aspectRatio), adjustedSpacing));
                float mod2 = step( adjustedPenSize, mod( vUv.x + (vUv.y/ aspectRatio), adjustedSpacing ) );
                float mod3 = step( adjustedPenSize, mod( vUv.x - 0.035, adjustedSpacing ) );
                float mod4 = step( adjustedPenSize, mod( (vUv.y / aspectRatio) - 0.035, adjustedSpacing ) );

                vec2 position = vec2(vUv.x,vUv.y/aspectRatio) / actualSize.xy;
                vec2 gridPosition = mod(position * actualSize.xy / actualSpacing, 1.0);
                vec2 circleCenter = vec2(0.5, 0.5);
                float distanceFromCenter = length(gridPosition - circleCenter);
                float normalizedRadius = radius / actualSpacing;
                float style = vtype == 1.0 ? riserStyle : fillOptions.y;

                if(isNotchPlane){
                    gl_FragColor = vec4(0.0, 0.0, 0.0, 0.0);
                } else if( (style <= 1.0) ||
                    (style == 2.0 && mod1 < 0.5) ||
                    (style == 3.0 && mod2 < 0.5) ||
                    (style == 4.0 && (mod1 < 0.5 || mod2 < 0.5)) ||
                    (style == 5.0 && mod4 < 0.5) ||
                    (style == 6.0 && mod3 < 0.5) ||
                    (style == 7.0 && distanceFromCenter < normalizedRadius)){
                    if(vdepth >= 0.0 && textureOptions != vec4(0.0, 0.0, 0.0, 0.0) && textureSize( image, 0 ).x != 0 && textureSize( image, 0 ).y != 0){
                        gl_FragColor = textureOptions;
                    }else{
                        gl_FragColor = vtype == 1.0 ? vec4(GetRGB(riserColour), riserTransparency) : vec4(GetRGB(fillOptions.x), effectiveAlpha);
                    }
                } else{
                    if(vdepth >= 0.0 && textureOptions != vec4(0.0, 0.0, 0.0, 0.0) && textureSize( image, 0 ).x != 0 && textureSize( image, 0 ).y != 0){
                        gl_FragColor = textureOptions;
                    }else{
                        gl_FragColor = vec4(1.0, 1.0, 1.0, effectiveAlpha);
                    }
                }
                if( !isNotchPlane && thickness > 0.0 && (vUv.x < vborders.x || vUv.x > 1.0 - vborders.x || vUv.y < vborders.y || vUv.y > 1.0 - vborders.y)) {
                    gl_FragColor = vec4( GetRGB( linecolour ), 1.0 );
                } else {
                    if(!isNotchPlane && effectiveAlpha == 0.0){ discard;}
                    if (vNormal.z == 1.0 && (vtype == 0.0 || isNotchPlane)){
                        float effectiveHeight = actualSize.y;
                        float combinedVUvY = vUv.y;
                        float combinedFlippedY = 1.0 - combinedVUvY;

                        float pegHoleRow1Width = (1.0 / actualSize.x) * merchRows1.x;
                        float pegHoleRow1Height = (1.0 / effectiveHeight) * merchRows1.y;
                        float pegHoleRow1StartX = (1.0 / actualSize.x) * merchRows1.z;
                        float pegHoleRow1StartY = (1.0 / effectiveHeight) * merchRows1.w;
                        float pegHoleRow1SpacingX = (1.0 / actualSize.x) * merchRows2.x;
                        float pegHoleRow1SpacingY = (1.0 / effectiveHeight) * merchRows2.y;

                        float pegHoleRow2Width =  (1.0 / actualSize.x) * merchRows2.z;
                        float pegHoleRow2Height =  (1.0 / effectiveHeight) * merchRows2.w;
                        float pegHoleRow2StartX = (1.0 / actualSize.x) * merchRows3.x;
                        float pegHoleRow2StartY = (1.0 / effectiveHeight) * merchRows3.y;
                        float pegHoleRow2SpacingX = (1.0 / actualSize.x) * merchRows3.z;
                        float pegHoleRow2SpacingY = (1.0 / effectiveHeight) * merchRows3.w;

                        bool canDrawRow1 = pegHoleRow1SpacingY > 0.0 && pegHoleRow1Width > 0.0 && pegHoleRow1Height > 0.0;
                        bool canDrawRow2 = pegHoleRow2SpacingY > 0.0 && pegHoleRow2Width > 0.0 && pegHoleRow2Height > 0.0;

                        float leftBound = (1.0 / actualSize.x) * 0.5;
                        float widthBound = 1.0 - ((1.0 / actualSize.x) * 0.5);
                        float heightBound = 1.0 - ((1.0 / effectiveHeight) * 0.5);

                        float newX = vUv.x - pegHoleRow1StartX + (pegHoleRow1Width / 2.0);
                        float newX2 = vUv.x - pegHoleRow2StartX + (pegHoleRow2Width / 2.0);
                        float newY = combinedFlippedY - pegHoleRow1StartY + (pegHoleRow1Height / 2.0 );
                        float newY2 = combinedFlippedY - pegHoleRow2StartY + (pegHoleRow2Height / 2.0 );
                        float modX = mod( newX , pegHoleRow1SpacingX );
                        float modY = mod( newY , pegHoleRow1SpacingY );
                        float modX2 = mod( newX2 , pegHoleRow2SpacingX );
                        float modY2 = mod( newY2 , pegHoleRow2SpacingY );

                        bool row1 = canDrawRow1 && ( (pegHoleRow1SpacingX > 0.0 && newX > 0.0 && modX < pegHoleRow1Width) || pegHoleRow1SpacingX == 0.0 ) && newY < 1.0 && modY < pegHoleRow1Height;
                        bool row2 = canDrawRow2 && ( (pegHoleRow2SpacingX > 0.0 && newX2 > 0.0 && modX2 < pegHoleRow2Width) || pegHoleRow2SpacingX == 0.0 ) && newY2 < 1.0 && modY2 < pegHoleRow2Height;

                        if( vUv.x > leftBound && vUv.x < widthBound && combinedVUvY < heightBound && (row1 || row2) ){
                            gl_FragColor = vec4(0.0, 0.0, 0.0, effectiveAlpha );
                        }
                        if(notches1.x > 0.0 && notches2.w > 0.0){
                            float notchStyleType = notches1.y;
                            float notchWidth = (1.0 / actualSize.x) * notches1.z;
                            float notchHeight = (1.0 / effectiveHeight) * notches1.w;
                            float notchStartX = (1.0 / actualSize.x) * notches2.x;
                            float notchStartY = (1.0 / effectiveHeight) * notches2.y;
                            float notchSpacingX = (1.0 / actualSize.x) * notches2.z;
                            float notchSpacingY = (1.0 / effectiveHeight) * notches2.w;

                            float actualNotchHeight = (1.0 / effectiveHeight) * notches1.z;
                            float positionY = 0.0;

                            if(notchStyleType == 1.0 || notchStyleType == 4.0 || notchStyleType == 6.0){ actualNotchHeight = notchHeight; }

                            float rowIndex = ceil( (combinedVUvY - notchStartY) / max(0.0001, notchSpacingY) );
                            float totalSteps = ceil( max(0.0001, (effectiveHeight - notches2.y)) / max(0.0001, notches2.w) );
                            float notchLimit = step( totalSteps, rowIndex );

                            if(notchStyleType == 2.0 || notchStyleType == 5.0) {
                                float h = notchStartX + notchWidth/2.0;
                                if(notchStyleType == 5.0 && vUv.x > notchStartX + notchWidth + notchSpacingX &&
                                    vUv.x < (1.0 - notchStartX - notchWidth - notchSpacingX) ){ h = h + notchWidth + notchSpacingX; }
                                if( ((1.0 - vUv.x) > notchStartX && (1.0 - vUv.x) < notchStartX + notchWidth) ||
                                    ((1.0 - vUv.x) > notchStartX + notchWidth && (1.0 - vUv.x) < notchStartX + notchWidth * 2.0 + notchSpacingX) ){ h = 1.0 - h; }
                                float k = mod(combinedVUvY + notchHeight/2.0 + actualNotchHeight/2.0 - notchStartY, notchSpacingY);
                                float a = notchWidth/2.0;
                                float b = actualNotchHeight/2.0;
                                float ellipse = pow((vUv.x - h)/a, 2.0) + pow((k - actualNotchHeight/2.0)/b, 2.0) - 1.0;
                                positionY = 1.0 - step(0.0, -ellipse);
                            }else if(notchStyleType == 6.0){
                                float modBlock = mod( ( combinedVUvY - notchStartY + notchHeight - notchHeight/3.0 ), notchSpacingY );
                                bool isInBlock = step(notchHeight, mod( ( combinedVUvY - notchStartY  + notchHeight ), notchSpacingY )) == 0.0;
                                bool isMiddleRow = step((notchHeight/3.0), modBlock) == 0.0 &&
                                    ((vUv.x > notchStartX && vUv.x < notchStartX + notchWidth ) || ((1.0 - vUv.x) > notchStartX && (1.0 - vUv.x) < notchStartX + notchWidth )) ;
                                bool isleftColumn = isInBlock && ((vUv.x > notchStartX && vUv.x < notchStartX + notchWidth / 3.0) || ((1.0 - vUv.x) > notchStartX && (1.0 - vUv.x) < notchStartX + notchWidth / 3.0));
                                bool isRightColumn = isInBlock && ((vUv.x > notchStartX + (notchWidth/3.0) * 2.0  && vUv.x < notchStartX + notchWidth) ||
                                    ((1.0 - vUv.x) > notchStartX + (notchWidth/3.0) * 2.0  && (1.0 - vUv.x) < notchStartX + notchWidth));
                                if( (isMiddleRow || isleftColumn || isRightColumn )){ positionY = 0.0; }else{ positionY = 1.0; }
                            } else {
                                float calc = step( actualNotchHeight, mod( ( combinedVUvY - notchStartY  + notchHeight/2.0 + actualNotchHeight/2.0 ), notchSpacingY ));
                                bool singleColumnCheck = vUv.x > notchStartX && vUv.x < notchStartX + notchWidth ||
                                    (1.0 - vUv.x) > notchStartX && (1.0 - vUv.x) < notchStartX + notchWidth;
                                bool doubleColumnCheck = ( notchStyleType == 3.0 || notchStyleType == 4.0 ) && (vUv.x > notchStartX + notchWidth + notchSpacingX && vUv.x < notchStartX + notchWidth * 2.0 + notchSpacingX ||
                                    (1.0 - vUv.x) > notchStartX + notchWidth + notchSpacingX && (1.0 - vUv.x) < notchStartX + notchWidth * 2.0 + notchSpacingX);
                                if(calc == 0.0 && (singleColumnCheck || doubleColumnCheck)){ positionY = 0.0; }else{ positionY = 1.0; }
                            }

                            if( positionY == 0.0 && notchLimit == 0.0 ){
                                gl_FragColor = vec4(0.0, 0.0, 0.0, effectiveAlpha);
                            }
                        }
                    }
                    if(isNotchPlane && gl_FragColor.a <= 0.0){ discard; }
                }
            }`,
        vertexColors: true,
    });
    PlanogramObjectShader = new THREE.ShaderMaterial({
        transparent: true,
        uniforms: {},
        vertexShader: `

            // attribute vec4 size;
            attribute vec4 options;
            attribute vec4 frontBackFill;
            attribute vec4 topBottomFill;
            attribute vec4 leftRightFill;
            attribute vec4 drawingArgs1;
            attribute vec4 drawingArgs2;
            attribute vec4 drawingArgs3;

            varying vec4 vsize;
            varying vec4 voptions;
            varying vec4 vfrontBackFill;
            varying vec4 vtopBottomFill;
            varying vec4 vleftRightFill;
            varying vec4 vdrawingArgs1;
            varying vec4 vdrawingArgs2;
            varying vec4 vdrawingArgs3;

            varying vec2 vUv;
            varying vec3 vNormal;

            void main() {
                vec3 size = vec3( length(instanceMatrix[0].xyz), length(instanceMatrix[1].xyz), length(instanceMatrix[2].xyz) );
                vec3 axis = abs(normal);
                vsize = vec3( size.zy * axis.x + size.xz * axis.y + size.xy * axis.z, vsize.w );
                voptions = options;
                vfrontBackFill = frontBackFill;
                vtopBottomFill = topBottomFill;
                vleftRightFill = leftRightFill;
                vdrawingArgs1 = drawingArgs1;
                vdrawingArgs2 = drawingArgs2;
                vdrawingArgs3 = drawingArgs3;

                vNormal = normal;
                vUv = uv;
                
                gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
                #ifdef USE_INSTANCING
                    gl_Position = projectionMatrix * viewMatrix * modelMatrix * instanceMatrix * vec4(position, 1.0);
                #endif
            }
        `,
        fragmentShader: `

            varying vec3 vsize;
            varying vec4 voptions;
            varying vec4 vfrontBackFill;
            varying vec4 vtopBottomFill;
            varying vec4 vleftRightFill;
            varying vec4 vdrawingArgs1;
            varying vec4 vdrawingArgs2;
            varying vec4 vdrawingArgs3;

            varying vec2 vUv;
            varying vec3 vNormal;
            uniform sampler2DArray image;

            vec3 GetRGB(float colour){
                float r = floor(colour / 65536.0);
                float g = floor((colour - r * 65536.0) / 256.0);
                float b = mod(colour, 256.0);
                return vec3(r/255.0, g/255.0, b/255.0);
            }
                
            
            vec2 GetColourDirection ( vec4 fbFill, vec4 tbFill, vec4 lrFill, vec3 normal, float type){
                if( type >= 12.0) return vec2( fbFill.x, fbFill.y );
                if( normal.x == -1.0 ) return vec2( lrFill.x, lrFill.y );
                if( normal.x == 1.0) return vec2( lrFill.z, lrFill.w );
                if( normal.y == 1.0 ) return vec2( tbFill.x, tbFill.y );
                if( normal.y == -1.0 ) return vec2( tbFill.z, tbFill.w );
                if( normal.z == 1.0 ) return vec2( fbFill.x, fbFill.y );
                if( normal.z == -1.0 ) return vec2( fbFill.z, fbFill.w );
            }

            void main() {
                vec2 actualSize = GetDimensions( vsize.xyz, vNormal );
                float thickness = voptions.x;
                float linecolour = voptions.y;
                float vtype = voptions.z;
                float transparency = voptions.w;
                float fillcolour = 0.0;
                float vdepth = 0.0;

                vec2 fillOptions = GetColourDirection( vfrontBackFill, vtopBottomFill, vleftRightFill, vNormal, vtype );

                vec2 uv = vUv;
                uv.y = 1.0 - uv.y;
                vec4 textureOptions = texture( image, vec3( uv, vdepth ) );

                vec2 vborders = vec2( thickness / actualSize.x, thickness / actualSize.y );
                float aspectRatio = actualSize.x / actualSize.y;
                float penSize = 4.0;
                float spacing = 5.0;
                float adjustedSpacing = ( 1.0/actualSize.x) * (spacing + penSize/2.0);
                float actualSpacing = ( 1.0/actualSize.x) * spacing;
                float adjustedPenSize = penSize / actualSize.x;
                float radius = ( 1.0/actualSize.x) * (penSize / 2.0); // Radius is half the diameter

                float mod1 = step( adjustedPenSize, mod(vUv.x - (vUv.y / aspectRatio), adjustedSpacing));
                float mod2 = step( adjustedPenSize, mod( vUv.x + (vUv.y/ aspectRatio), adjustedSpacing ) );
                float mod3 = step( adjustedPenSize, mod( vUv.x - 0.035, adjustedSpacing ) );
                float mod4 = step( adjustedPenSize, mod( (vUv.y / aspectRatio) - 0.035, adjustedSpacing ) );

                vec2 position = vec2(vUv.x,vUv.y/aspectRatio) / actualSize.xy;
                vec2 gridPosition = mod(position * actualSize.xy / actualSpacing, 1.0);
                vec2 circleCenter = vec2(0.5, 0.5);
                float distanceFromCenter = length(gridPosition - circleCenter);
                float normalizedRadius = radius / actualSpacing;
                
                if( (fillOptions.y <= 1.0) ||
                    (fillOptions.y == 2.0 && mod1 < 0.5) || 
                    (fillOptions.y == 3.0 && mod2 < 0.5) || 
                    (fillOptions.y == 4.0 && (mod1 < 0.5 || mod2 < 0.5)) ||  
                    (fillOptions.y == 5.0 && mod4 < 0.5) || 
                    (fillOptions.y == 6.0 && mod3 < 0.5) || 
                    (fillOptions.y == 7.0 && distanceFromCenter < normalizedRadius)){
                    if(vdepth >= 0.0 && textureOptions != vec4(0.0, 0.0, 0.0, 0.0) && textureSize( image, 0 ).x != 0 && textureSize( image, 0 ).y != 0){
                        gl_FragColor = textureOptions;
                    }else{
                        gl_FragColor = vec4(GetRGB(fillOptions.x), transparency);
                    }
                } else{
                    if(vdepth >= 0.0 && textureOptions != vec4(0.0, 0.0, 0.0, 0.0) && textureSize( image, 0 ).x != 0 && textureSize( image, 0 ).y != 0){
                        gl_FragColor = textureOptions;
                    }else{
                        gl_FragColor = vec4(1.0, 1.0, 1.0, transparency);
                    }
                }
                if( vUv.x < vborders.x || vUv.x > 1.0 - vborders.x || vUv.y < vborders.y || vUv.y > 1.0 - vborders.y) {
                    gl_FragColor = vec4( GetRGB( linecolour ), 1.0 );
                } else {
                    if(transparency == 0.0){ discard;} 
                    if (vNormal.z == 1.0){
                        /// Peg board and Slot Wall
                        if( vtype == 2.0 || vtype == 3.0 || vtype == 9.0 || vtype == 11.0 ){

                            float pegHoleRow1Width = (1.0 / actualSize.x) * vdrawingArgs1.x;
                            float pegHoleRow1Height = (1.0 / actualSize.y) * vdrawingArgs1.y;
                            float pegHoleRow2Width =  (1.0 / actualSize.x) * vdrawingArgs1.z;
                            float pegHoleRow2Height =  (1.0 / actualSize.y) * vdrawingArgs1.w;
            
                            float pegHoleRow1StartX = (1.0 / actualSize.x) * vdrawingArgs2.x;
                            float pegHoleRow1StartY = (1.0 / actualSize.y) * vdrawingArgs2.y;
                            float pegHoleRow2StartX = (1.0 / actualSize.x) * vdrawingArgs2.z;
                            float pegHoleRow2StartY = (1.0 / actualSize.y) * vdrawingArgs2.w;
            
                            float pegHoleRow1SpacingX = (1.0 / actualSize.x) * vdrawingArgs3.x;
                            float pegHoleRow1SpacingY = (1.0 / actualSize.y) * vdrawingArgs3.y;
                            float pegHoleRow2SpacingX = (1.0 / actualSize.x) * vdrawingArgs3.z;
                            float pegHoleRow2SpacingY = (1.0 / actualSize.y) * vdrawingArgs3.w;
            
                            bool canDrawRow1 = vdrawingArgs3.y > 0.0 && vdrawingArgs1.x > 0.0 && vdrawingArgs1.y > 0.0;
                            bool canDrawRow2 = vdrawingArgs3.w > 0.0 && vdrawingArgs1.z > 0.0 && vdrawingArgs1.w > 0.0;
            
                            float leftBound = (1.0 / actualSize.x) * 0.5;
                            float widthBound = 1.0 - ((1.0 / actualSize.x) * 0.5);
                            float heightBound = 1.0 - ((1.0 / actualSize.y) * 0.5);

                            float newX = vUv.x - pegHoleRow1StartX + (pegHoleRow1Width / 2.0);
                            float newX2 = vUv.x - pegHoleRow2StartX + (pegHoleRow2Width / 2.0);
                            // float newY = vUv.y 
                            float flippedY = 1.0 - vUv.y;
                            float newY = flippedY - pegHoleRow1StartY + (pegHoleRow1Height / 2.0 );
                            float newY2 = flippedY - pegHoleRow2StartY + (pegHoleRow2Height / 2.0 );
                            float modX = mod( newX , pegHoleRow1SpacingX );
                            float modY = mod( newY , pegHoleRow1SpacingY );
                            float modX2 = mod( newX2 , pegHoleRow2SpacingX );
                            float modY2 = mod( newY2 , pegHoleRow2SpacingY );

                            bool row1 = canDrawRow1 && ( (pegHoleRow1SpacingX > 0.0 && newX > 0.0 && modX < pegHoleRow1Width) || pegHoleRow1SpacingX == 0.0 ) && newY < 1.0 && modY < pegHoleRow1Height;
                            bool row2 = canDrawRow2 && ( (pegHoleRow2SpacingX > 0.0 && newX2 > 0.0 && modX2 < pegHoleRow2Width) || pegHoleRow2SpacingX == 0.0 ) && newY2 < 1.0 && modY2 < pegHoleRow2Height;

                            if( vUv.x > leftBound && vUv.x < widthBound && vUv.y < heightBound && (row1 || row2) ){
                                gl_FragColor = vec4(0.0, 0.0, 0.0, transparency );
                            }
                        /// Backboard
                        }else if(vtype == 5.0 && vdrawingArgs2.z != 7.0){

                            float notchStartX = (1.0 / actualSize.x) * vdrawingArgs1.x;
                            float notchStartY = (1.0 / actualSize.y) * vdrawingArgs1.y;
                            float notchWidth = (1.0 / actualSize.x) * vdrawingArgs1.z;
                            float notchHeight = (1.0 / actualSize.y) * vdrawingArgs1.w;
                            float notchSpacingX = (1.0 / actualSize.x) * vdrawingArgs2.x;
                            float notchSpacingY = (1.0 / actualSize.y) * vdrawingArgs2.y;
                            float notchStyleType = vdrawingArgs2.z;
                            float actualNotchHeight = (1.0 / actualSize.y) * vdrawingArgs1.z;
                            float positionY = 0.0;

                            if(notchStyleType == 1.0 || notchStyleType == 4.0 || notchStyleType == 6.0){ actualNotchHeight = notchHeight; }

                            float rowIndex = ceil( (vUv.y - notchStartY) / max(0.0001, notchSpacingY) );
                            float totalSteps = ceil( max(0.0001, (actualSize.y - vdrawingArgs1.y)) / max(0.0001, vdrawingArgs2.y) );
                            float notchLimit = step( totalSteps, rowIndex );

                            if(notchStyleType == 2.0 || notchStyleType == 5.0) {
                                float h = notchStartX + notchWidth/2.0;
                                if(notchStyleType == 5.0 && vUv.x > notchStartX + notchWidth + notchSpacingX &&
                                    vUv.x < (1.0 - notchStartX - notchWidth - notchSpacingX) ){ h = h + notchWidth + notchSpacingX; }
                                if( ((1.0 - vUv.x) > notchStartX && (1.0 - vUv.x) < notchStartX + notchWidth) ||
                                    ((1.0 - vUv.x) > notchStartX + notchWidth && (1.0 - vUv.x) < notchStartX + notchWidth * 2.0 + notchSpacingX) ){ h = 1.0 - h; }
                                float k = mod(vUv.y + notchHeight/2.0 + actualNotchHeight/2.0 - notchStartY, notchSpacingY);
                                float a = notchWidth/2.0;
                                float b = actualNotchHeight/2.0;
                                float ellipse = pow((vUv.x - h)/a, 2.0) + pow((k - actualNotchHeight/2.0)/b, 2.0) - 1.0;
                                positionY = 1.0 - step(0.0, -ellipse);
                            }else if(notchStyleType == 6.0){
                                float modBlock = mod( ( vUv.y - notchStartY + notchHeight - notchHeight/3.0 ), notchSpacingY );
                                bool isInBlock = step(notchHeight, mod( ( vUv.y - notchStartY  + notchHeight ), notchSpacingY )) == 0.0;
                                bool isMiddleRow = step((notchHeight/3.0), modBlock) == 0.0 &&
                                    ((vUv.x > notchStartX && vUv.x < notchStartX + notchWidth ) || ((1.0 - vUv.x) > notchStartX && (1.0 - vUv.x) < notchStartX + notchWidth )) ;
                                bool isleftColumn = isInBlock && ((vUv.x > notchStartX && vUv.x < notchStartX + notchWidth / 3.0) || ((1.0 - vUv.x) > notchStartX && (1.0 - vUv.x) < notchStartX + notchWidth / 3.0));
                                bool isRightColumn = isInBlock && ((vUv.x > notchStartX + (notchWidth/3.0) * 2.0  && vUv.x < notchStartX + notchWidth) ||
                                    ((1.0 - vUv.x) > notchStartX + (notchWidth/3.0) * 2.0  && (1.0 - vUv.x) < notchStartX + notchWidth));
                                if( (isMiddleRow || isleftColumn || isRightColumn )){ positionY = 0.0; }else{ positionY = 1.0; }
                            } else {
                                float calc = step( actualNotchHeight, mod( ( vUv.y - notchStartY  + notchHeight/2.0 + actualNotchHeight/2.0 ), notchSpacingY ));
                                bool singleColumnCheck = vUv.x > notchStartX && vUv.x < notchStartX + notchWidth ||
                                    (1.0 - vUv.x) > notchStartX && (1.0 - vUv.x) < notchStartX + notchWidth;
                                bool doubleColumnCheck = ( notchStyleType == 3.0 || notchStyleType == 4.0 ) && (vUv.x > notchStartX + notchWidth + notchSpacingX && vUv.x < notchStartX + notchWidth * 2.0 + notchSpacingX ||
                                    (1.0 - vUv.x) > notchStartX + notchWidth + notchSpacingX && (1.0 - vUv.x) < notchStartX + notchWidth * 2.0 + notchSpacingX);
                                if(calc == 0.0 && (singleColumnCheck || doubleColumnCheck)){ positionY = 0.0; }else{ positionY = 1.0; }
                            }

                            if( positionY == 0.0 && notchLimit == 0.0 ){
                                gl_FragColor = vec4(0.0, 0.0, 0.0, transparency);
                            }
                        }
                    }
                }
            }`,
        vertexColors: true,
    });
}

export class PlanogramRendererAttributes {
    static Attributes = {
        ShowStatusBar: 'show-status-bar',
        DisableSelect: 'disable-select',
        SelectionColour: 'selection-colour',
        HideTabs: 'hide-tabs',
        DisableTabDrag: 'disable-tab-drag',
        TabActiveBehaviour: 'tab-active-behaviour',
        SplitCameraBehaviour: 'split-camera-behaviour',
        JoinCameraBehaviour: 'join-camera-behaviour',
        WireframePositions: 'wireframe-positions',
        IgnorePositions: 'ignore-positions',
        IgnoreSubcomponents: 'ignore-subcomponents',
        IncludeBlocking: 'include-blocking',
        ChestWallTransparency: 'chest-wall-transparency',
        InteractInFocus: 'interact-in-focus', // When this is set, only interactions with an in focus camera will work
        FrameCap: 'frame-cap',
        ShowFrameRate: 'show-frame-rate',
        MiniMapConsistentSize: 'minimap-consistent-size',
        ConstrainToFace: 'constrain-to-face',
        SnappingDistance: 'snapping-distance',
        HangingGap: 'hanging-gap'
    }

    static DeveloperAttributes = {
        ShowMessages: 'show-messages',
        ShowBoundingBoxes: 'show-bounding-boxes',
    }
}

export class PlanogramObjectAttributes {
    static Attributes = {
        Name: 'name',
        X: 'x',
        Y: 'y',
        Z: 'z',
        RotationX: 'rotation-x',
        RotationY: 'rotation-y',
        RotationZ: 'rotation-z',
        Selected: 'selected',
        Transparency: 'transparency',
        LineThickness: 'line-thickness',
        LineColour: 'line-colour',
        LabelText: 'label-text',
    }
}

export class PlanogramContainerAttributes {
    static Attributes = {
        ContainerId: 'container-id',
        PlanogramName: 'planogram-name',
        ImagesEnabled: 'images-enabled',
        HideChestWalls: 'hide-chest-walls',
        AutoZoom: 'auto-zoom',
        Width: 'width',
        Height: 'height',
        Depth: 'depth',
        ShowPositionsThroughBlocking: 'show-positions-through-blocking',
        GroupName: 'group-name',
        GroupFrameId: 'group-frame-id',
        GroupFrameIndex: 'group-frame-index',
        GroupFocused: 'group-focused',
        ComponentTransform: 'component-transform',
        AddBox: 'add-box'
    }
}

export class PlangoramCameraAttributes {
    static Attributes = {
        CameraName: 'camera-name',
        ContainerId: 'container-id',
        CameraFrameIndex: 'camera-frame-index',
        PositionX: 'position-x',
        PositionY: 'position-y',
        PositionZ: 'position-z',
        LookAtX: 'look-at-x',
        LookAtY: 'look-at-y',
        LookAtZ: 'look-at-z',
        DefaultPosition: 'default-position',
        DefaultLookAt: 'default-look-at',
        Type: 'type',
        Control: 'control',
        Zoom: 'zoom',
        ZoomDisabled: 'zoom-disabled',
        Active: 'active',
        DockRow: 'dock-row',
        DockColumn: 'dock-column',
        DisableClose: 'disable-close',
        MiniMap: 'mini-map',
        LockVertical: 'lock-vertical',
        LockTab: 'lock-tab',
        Focused: 'focused',
        Collapsed: 'collapsed',
        Icon: 'icon',
        ShowGrid: 'show-grid'
    }
}

export class PlanogramCameraFrameAttributes {
    static Attributes = {
        ChildFrameDirection: 'child-frame-direction',
        Size: 'size',
        NoResize: 'no-resize',
        NoTab: 'no-tab',
        Fixed: 'fixed'
    }
}

export class PlanogramSubcomponentAttributes {
    static CommonAttributes = {
        Type: 'type',
        Width: 'width',
        Height: 'height',
        Depth: 'depth',
        FrontColour: 'front-colour',
        BackColour: 'back-colour',
        LeftColour: 'left-colour',
        RightColour: 'right-colour',
        TopColour: 'top-colour',
        BottomColour: 'bottom-colour',
        FrontStyle: 'front-style',
        BackStyle: 'back-style',
        LeftStyle: 'left-style',
        RightStyle: 'right-style',
        TopStyle: 'top-style',
        BottomStyle: 'bottom-style',
        FillStyle: 'fillStyle',
        FillColour: 'fillColour',
        FillFace: 'fillFace',
        SnapAnchor: 'snap-anchor'
    }

    static BackBoardAttributes = {
        NotchType: 'type',
        ShowNotches: 'showNotches',
        NotchStartX: 'startX',
        NotchStartY: 'startY',
        NotchSpacingX: 'spacingX',
        NotchSpacingY: 'spacingY',
        NotchWidth: 'width',
        NotchHeight: 'height',
        NotchYOffset: 'yOffset',
    }

    static PegBoardClipStripSlotwallAttributes = {
        Width: 'width',
        Height: 'height',
        StartX: 'startX',
        StartY: 'startY',
        SpacingX: 'spacingX',
        SpacingY: 'spacingY',
    }

    static ShelfAttributes = {
        RiserColour: 'riserColour',
        RiserHeight: 'riser-height',
        RiserThickness: 'riser-thickness',
        RiserTransparency: 'riserTransparency',
        RiserFillStyle: 'riserFillStyle',
        ShowBack: 'show-back',
        ShowFront: 'show-front',
        ShowLeft: 'show-left',
        ShowRight: 'show-right'
    }

    static ChestAttributes = {
        FaceThicknessFront: 'face-thickness-front',
        FaceThicknessBack: 'face-thickness-back',
        FaceThicknessLeft: 'face-thickness-left',
        FaceThicknessRight: 'face-thickness-right',
        FaceThicknessTop: 'face-thickness-top',
        FaceThicknessBottom: 'face-thickness-bottom'
    }
}

export class DividerAttributes {
    static DividerAttributes = {
        X: 'x',
        Y: 'y',
        Z: 'z',
        Width: 'width',
        Height: 'height',
        Depth: 'depth',
        Colour: 'colour',
        FillStyle: 'fill-style',
    }
}

export class PegAttributes {
    static PegAttributes = {
        X: 'x',
        Y: 'y',
        Depth: 'depth',
        TagWidth: 'tag-width',
        TagHeight: 'tag-height',
        TagXOffset: 'tag-x-offset',
        TagYOffset: 'tag-y-offset',
        UpperStart: 'upper-start',
        DrawUpper: 'draw-upper',
        DrawTag: 'draw-tag'
    }
}

export class PlanogramPositionAttributes {
    static PositionAttributes = {
        ProductId: 'product-id',
        Colour: 'colour'
    }
}

export class PlanogramPositionCapAttributes {
    static CapAttributes = {
        X: 'x',
        Y: 'y',
        Z: 'z',
        RotationX: 'rotation-x',
        RotationY: 'rotation-y',
        RotationZ: 'rotation-z',
        Wide: 'wide',
        High: 'high',
        Deep: 'deep',
        FacingSpaceX: 'facing-space-x',
        FacingSpaceY: 'facing-space-y',
        FacingSpaceZ: 'facing-space-z',
        Width: 'width',
        Height: 'height',
        Depth: 'depth',
        Type: 'type'
    }
}